import { SimulatorWizard } from "@/components/public/SimulatorWizard";
import { HeartPulse, Ambulance, Glasses, Ear } from "lucide-react";
import { Tooth } from "@/components/icons/Tooth";

const steps = [
  {
    title: "Votre profil",
    description: "Ces informations nous aident à estimer la tarification. Aucune donnée médicale détaillée n'est demandée.",
    fields: [
      { name: "composition", label: "Qui souhaitez-vous assurer ?", type: "radio", required: true, options: [
        { value: "seul", label: "Personne seule" }, { value: "couple", label: "Couple" }, { value: "famille", label: "Famille" } ] },
      { name: "date_naissance", label: "Votre date de naissance", type: "date", required: true },
      { name: "date_naissance_conjoint", label: "Date de naissance du conjoint (si applicable)", type: "date" },
      { name: "nb_enfants", label: "Nombre d'enfants à assurer", type: "select", options: [
        { value: "0", label: "Aucun" }, { value: "1", label: "1" }, { value: "2", label: "2" }, { value: "3", label: "3 et +" } ] },
      { name: "code_postal", label: "Code postal", type: "text", required: true, placeholder: "75001" },
      { name: "situation_pro", label: "Situation professionnelle", type: "select", options: [
        { value: "salarie", label: "Salarié(e)" }, { value: "tns", label: "Indépendant / TNS" },
        { value: "retraite", label: "Retraité(e)" }, { value: "etudiant", label: "Étudiant(e)" },
        { value: "sans_emploi", label: "Sans emploi" }, { value: "sans_profession", label: "Sans profession" } ] },
      { name: "date_effet", label: "Date d'effet souhaitée", type: "date", required: true },
    ],
  },
  {
    title: "Vos besoins en garanties",
    description: "Évaluez vos besoins sur ces postes de santé afin de vous proposer les produits adaptés.",
    fields: [
      { name: "besoins", type: "needs_grid", required: true, label: "Pour chaque poste, indiquez votre niveau de besoin", posts: [
        { key: "soins_medicaux", label: "Soins médicaux", desc: "(médecin, pharmacie, radios, etc.)", icon: HeartPulse, info: "Consultations, médicaments, analyses et examens de radiologie remboursés par la mutuelle en complément de la Sécurité sociale." },
        { key: "hospitalisation", label: "Hospitalisation", desc: "(frais de séjour, transport, chirurgie, etc.)", icon: Ambulance, info: "Frais de séjour, forfait journalier, honoraires chirurgicaux, chambre particulière et transport." },
        { key: "dentaire", label: "Dentaire", desc: "(dentiste, prothèses, soins, etc.)", icon: Tooth, info: "Soins dentaires, prothèses, couronnes, implants et orthodontie selon les contrats." },
        { key: "optique", label: "Optique", desc: "(lentilles, lunettes, chirurgie réfractive, etc.)", icon: Glasses, info: "Montures, verres, lentilles et, selon les contrats, chirurgie réfractive." },
        { key: "auditif", label: "Aides auditives", desc: "(appareillages auditifs, etc.)", icon: Ear, info: "Prothèses auditives et accessoires, en complément du dispositif 100% Santé." },
      ] },
    ],
  },
  {
    title: "Vos préférences",
    fields: [
      { name: "budget", label: "Budget mensuel indicatif", type: "slider", min: 10, max: 300, step: 5, default: 60, unit: " €" },
      { name: "priorite", label: "Votre priorité", type: "radio", required: true, options: [
        { value: "prix", label: "Le prix le plus bas" }, { value: "garanties", label: "Les meilleures garanties" }, { value: "equilibre", label: "Le meilleur équilibre" } ] },
      { name: "couverture_actuelle", label: "Avez-vous déjà une mutuelle ?", type: "radio", options: [
        { value: "oui", label: "Oui" }, { value: "non", label: "Non" } ] },
    ],
  },
];

export default function SimulateurMutuelle() {
  return <SimulatorWizard simType="mutuelle_france" title="Parcours A — Mutuelle santé France" subtitle="Comparez les mutuelles santé" steps={steps} />;
}
